// extracted by mini-css-extract-plugin
export default {"Input":"LargeInput_Input__Ru9oQ","InputContainer":"LargeInput_InputContainer__3meaw"};